import React, { useEffect } from 'react';

const ToggleThemeBtn = () => {
  const setTheme = (theme: string) => {
    const html = document.querySelector('html');
    html?.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  };
  const getTheme = () => {
    const localStorageTheme = localStorage.getItem('theme');
    if (localStorageTheme) {
      return localStorageTheme;
    }

    const systemDark = window.matchMedia('(prefers-color-scheme: dark)');
    return systemDark.matches ? 'dark' : 'light';
  };
  useEffect(() => {
    let currentTheme = getTheme();
    setTheme(currentTheme);

    // Change theme based on system theme
    const systemChange = () => setTheme(getTheme());
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)');
    systemDark.addEventListener('change', systemChange);

    const toggleBtns = document.querySelectorAll('[data-theme-toggle]');
    const handleThemeToggle = () => {
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      currentTheme = newTheme;
      setTheme(newTheme);
    };
    toggleBtns.forEach((btn) =>
      btn.addEventListener('click', handleThemeToggle),
    );

    // Clean up event
    return () => {
      systemDark.removeEventListener('change', systemChange);
      toggleBtns.forEach((btn) =>
        btn.removeEventListener('click', handleThemeToggle),
      );
    };
  }, []);

  return (
    <div
      className="theme_btn"
      role="button"
      tabIndex={0}
      aria-label="Toggle Theme"
      data-theme-toggle
    >
      <div className="theme_indicator"></div>
      <div className="theme_container">
        <div className="theme_moon_icon"></div>
        <div className="theme_sun_icon"></div>
      </div>
    </div>
  );
};

export default ToggleThemeBtn;
